import React from 'react';
import { Provider } from 'mobx-react';

import type RootStore from '../../stores/RootStore';

interface RootStoreProviderProps {
  rootStore: RootStore;
  children: React.ReactNode;
}

const RootStoreProvider = React.forwardRef<
  HTMLDivElement,
  RootStoreProviderProps
>(({ rootStore, children }, ref) => {
  return (
    <Provider rootStore={rootStore} {...rootStore}>
      <div ref={ref}>{children}</div>
    </Provider>
  );
});

RootStoreProvider.displayName = 'RootStoreProvider';

export default RootStoreProvider;
